import styled from 'styled-components';

const CommonPagesWrapper = styled.div`


`;

export default CommonPagesWrapper;